import { getTranslation, keys } from '../../../Resources/Translations';
import { RegexProvider } from '../RegexProvider';
import { FormDataTypes, FormField, FormFields, ValidationIssue, ValidationType } from './FormInterfaces';

export const getValidationIssue = (input: FormField, inputs: FormFields, value: FormDataTypes): ValidationIssue[] => {
    const validationIssues: ValidationIssue[] = [];
    const { validation, displayName } = input;

    const emailRegEx = RegexProvider.email;

    const getDefaultErrorMessage = (displayName: string, defaultMessage: string): string => {
        return `${displayName} ${defaultMessage}`;
    };
    if (!validation) return validationIssues;

    if ((value as string).trim) value = (value as string).trim();

    if (validation.required && !value) {
        validationIssues.push({
            type: getValidationType(validation.required),
            message: validation.required.message || getDefaultErrorMessage(displayName, getTranslation(keys['form.errors.required']))
        });
    }
    if (validation.minLength && (!value || (value as string).length < validation.minLength.value)) {
        validationIssues.push({
            type: getValidationType(validation.minLength),
            message:
                validation.minLength.message ||
                getDefaultErrorMessage(displayName, `${getTranslation(keys['form.errors.minLength'])} (${validation.minLength.value})`)
        });
    }
    if (validation.maxLength && value && (value as string).length > validation.maxLength.value) {
        validationIssues.push({
            type: getValidationType(validation.maxLength),
            message:
                validation.maxLength.message ||
                getDefaultErrorMessage(displayName, `${getTranslation(keys['form.errors.maxLength'])} (${validation.maxLength.value})`)
        });
    }
    if (validation.sameValueAs && inputs.hasOwnProperty(validation.sameValueAs.value)) {
        if (value !== inputs[validation.sameValueAs.value].value) {
            validationIssues.push({
                type: getValidationType(validation.sameValueAs),
                message:
                    validation.sameValueAs.message ||
                    getDefaultErrorMessage(
                        displayName,
                        `${getTranslation(keys['form.errors.sameValueAs'])} ${inputs[validation.sameValueAs.value].displayName}`
                    )
            });
        }
    }
    validation.regEx?.forEach((regEx) => {
        if (value && !regEx.value.test(value as string))
            validationIssues.push({
                type: getValidationType(regEx),
                message: regEx.message
            });
    });
    if (validation.email && value && !emailRegEx.test(value as string)) {
        validationIssues.push({
            type: getValidationType(validation.email),
            message: validation.email.message || getDefaultErrorMessage(displayName, getTranslation(keys['form.errors.email']))
        });
    }

    validationIssues.sort((a, b) => a.type - b.type);
    return validationIssues.length >= 1 ? [validationIssues[0]] : [];
};

export const isInputDisabled = (input: FormField, inputs: FormFields): boolean => {
    const { disableWhen } = input;

    if (disableWhen) {
        if (disableWhen.hasValue && inputs[disableWhen.hasValue.value].value) {
            return true;
        }
    }

    return !!input.disabled;
};

function getValidationType(validation: { message?: string; type?: ValidationType }): ValidationType {
    return validation?.type || ValidationType.Error;
}
